import React, { Component } from 'react';
import { connect } from 'react-redux'
import {closePopup} from "../../../actions/popup";
import autobind from 'autobind-decorator'
import WindowEventHelper from "../../../lib/WindowEventHelper";
import { moveCategory } from '../../../actions/category'
import TSelectForm from "../../common/TSelectForm";
import classnames from 'classnames';
import If from "../../common/control/If";
import SimpleDialog from "../../common/SimpleDialog";

@connect(state => ({
  isPopupOpened: (typeof state.popup !== 'undefined' && state.popup.isMovingCategoryOpened),
  categoryTree : state.category.categoryTree,
  category: state.popup.category
}), dispatch => ({
  handleMoveCategory: (category, to, placement) => {
    dispatch(moveCategory(category, to, placement))
  },
  handlePopupClose: () => {
    dispatch(closePopup())
  },
}))
export default class CategoryMovePopupLayer extends Component {

  constructor(props) {
    super(props);

    this.state = {
      selectedOneDepthCategory : null,
      selectedOneDepthCategoryIdx : -1,
      selectedTwoDepthCategory : null,
      placement : null,
    }
  }

  componentDidMount() {
    WindowEventHelper.add("keydown", this.handleKeyDown)
    document.body.className = "scroll_hide";
  }

  componentWillUnmount() {
    WindowEventHelper.remove("keydown", this.handleKeyDown)
    document.body.className = "";
  }

  componentWillReceiveProps(nextProps) {

    if(nextProps.category === null){
      this.setState({
        selectedOneDepthCategory : null,
        selectedOneDepthCategoryIdx : -1,
        selectedTwoDepthCategory : null,
        placement : null,
      });
    }
  }


  @autobind
  handleKeyDown(e) {
    const keyCode = e.keyCode;
    if (keyCode == 27) {
      this.props.handlePopupClose();
    }
  }

  @autobind
  selectOneDepthCategory(item, idx) {
    this.setState({
      selectedOneDepthCategory : item.value,
      selectedOneDepthCategoryIdx : idx,
      selectedTwoDepthCategory: null,
      placement:null
    })
  }

  @autobind
  selectTwoDepthCategory(item, idx) {

    this.setState({
      selectedTwoDepthCategory: item.value,
      placement:null
    });
  }

  render() {
    const { category, handlePopupClose } = this.props;
    if(category === null)
      return null;

    const hasChild  = (category.children && category.children.length > 0);
    const { selectedOneDepthCategory , selectedTwoDepthCategory , placement  } = this.state;

    let oneDepthOptions = this.getOneDepthOptions();
    let twoDepthOptions = this.getTwoDepthOptions(oneDepthOptions, hasChild);

    return (
      <SimpleDialog
        title={`'${category.name}' 이동`}
        className="inner_blog_layer5"
        style={{position: 'fixed', top: '50%', marginTop: "-227px", zIndex: 10}}
        validated={placement !== null}
        onClose={() => handlePopupClose()}
        onSubmit={(e) => this.moveCategory(e)}
      >
        <p className="txt_popup">카테고리를 옮길 기준이 되는 카테고리를 선택하세요.</p>

        <div className="wrap_set">
          <div className="item_set item_sub">{(hasChild)?"":"상위"}
            <TSelectForm className={"opt_set opt_category"} items={oneDepthOptions}
                         selected={selectedOneDepthCategory}
                         onSelect={(item, idx) => this.selectOneDepthCategory(item, idx)}/>
          </div>
          <If condition={!hasChild} >
            <div className="item_set item_sub">하위
              <TSelectForm className={"opt_set opt_category"} items={twoDepthOptions}
                           selected={selectedTwoDepthCategory}
                           onSelect={(item, idx) => this.selectTwoDepthCategory(item, idx)}
                           disabled={(selectedOneDepthCategory === null || twoDepthOptions.length === 1)}/>
            </div>
          </If>
        </div>
        <div className="radio_blog radio_cate">
          <label className="lab_set">
            <input type="radio" name="moveCate" className="inp_set"
                   checked={(placement === 'before')}
                   disabled={(selectedOneDepthCategory === null)}
                   onClick={(e) => this.setState({placement : 'before'})}/>
            <span className="txt_set"><span className="ico_addcate ico_addcate1"/>선택한 카테고리 위로 카테고리를 옮깁니다.</span>
          </label>
          <label className="lab_set">
            <input type="radio" name="moveCate" className="inp_set"
                   checked={(placement === 'after')}
                   disabled={(selectedOneDepthCategory === null)}
                   onClick={(e) => this.setState({placement : 'after'})}/>
            <span className="txt_set"><span className="ico_addcate ico_addcate2"/>선택한 카테고리 아래로 카테고리를 옮깁니다.</span>
          </label>
          <If condition={!hasChild} >
            <label className="lab_set">
              <input type="radio" name="moveCate" className="inp_set"
                     checked={(placement === 'append')}
                     disabled={(selectedOneDepthCategory === null) || (selectedTwoDepthCategory !== null)}
                     onClick={(e) => this.setState({placement: 'append'})}/>
              <span className="txt_set"><span className="ico_addcate ico_addcate3"/>선택한 카테고리의 하위 카테고리로 옮깁니다.</span>
            </label>
          </If>
        </div>
      </SimpleDialog>
    );
  }

  @autobind
  moveCategory(e){

    const { category, handleMoveCategory, handlePopupClose } = this.props;

    const { selectedOneDepthCategory, selectedTwoDepthCategory, placement } = this.state;

    // 두번째 하위 카테고리가 선택되어 있으면, 두번째 카테고리로 이동
    if(selectedTwoDepthCategory) {
      handleMoveCategory(category, selectedTwoDepthCategory, placement);
    }else{
      handleMoveCategory(category, selectedOneDepthCategory, placement);
    }

    handlePopupClose();
    e.preventDefault();

  }

  @autobind
  getOneDepthOptions() {

    const { category, categoryTree } = this.props;

    let options = [{ label : '선택되지 않음', value: null}];

    categoryTree.forEach((item) => {

      // 이동하려는 카테고리가 1depth인 경우 - 자기자신이 아니어야 하고
      // 이동하려는 카테고리가 2depth인 경우 - 자신의 상위 카테고리가 아니어야함.
      if(item.id !== category.id && item.id !== category.parent){
        options.push({ label : item.name, value : item.id, children:item.children});
      }
    });

    return options;

  }

  @autobind
  getTwoDepthOptions(oneDepthOptions, hasChild) {

    const { category } = this.props;
    const { selectedOneDepthCategoryIdx } = this.state;

    let options = [{ label : '선택되지 않음', value: null}];

    // 이동하려는 카테고리가 1depth인 경우 - 카테고리가 하위 자식들을 가지고 있지 않은 경우에만 가능
    // 상위 카테고리가 선택된 경우에만 2depth 카테고리 파악.
    if(!hasChild && selectedOneDepthCategoryIdx > 0) {

      oneDepthOptions[selectedOneDepthCategoryIdx]['children'].forEach((item) => {
        // 이동하려는 카테고리가 2depth인 경우 - 자기자신이 아니어야함.
        if(item.id !== category.id) {
          options.push({label: item.name, value: item.id});
        }
      });
    }

    return options;
  }
}
